export default {
  namespaced: true,
  state: {
    showPopup: false,
    message: "请使用手机号登录后再投票",
    confirmBtnText: "前往登录",
    confirmCallback: null,
    beforeShowPopupCallback: null,
    beforeCloseCallback: null
  },
  getters: {
    showPopup: state => state.showPopup,
    message: state => state.message,
    confirmBtnText: state => state.confirmBtnText,
    confirmCallback: state => state.confirmCallback
  },
  mutations: {
    showPopup(state, options) {
      state.beforeShowPopupCallback && state.beforeShowPopupCallback()
      Object.assign(state, options)
      state.showPopup = true
    },
    closePopup(state) {
      state.beforeCloseCallback && state.beforeCloseCallback()
      state.showPopup = false
    }
  }
}
